import { cx } from "../../lib/cx.js";
/* empty css                     */
import { forwardRef, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/SegmentedControl/SegmentedControl.tsx
var NEXT = {
	ArrowRight: 1,
	ArrowDown: 1,
	ArrowLeft: -1,
	ArrowUp: -1
};
/**
* A compact switch between a few mutually exclusive choices, e.g. a list's view or
* filter. A radio group: Tab reaches the selected segment, the arrow keys move and select.
*/
var SegmentedControl = forwardRef(function SegmentedControl({ options, value, onChange, size = "md", fluid = false, className, ...rest }, ref) {
	const buttons = useRef([]);
	const enabled = options.flatMap((option, index) => option.disabled ? [] : [index]);
	const selected = options.findIndex((option) => option.value === value);
	const tabStop = selected >= 0 && !options[selected].disabled ? selected : enabled[0];
	const select = (index) => {
		buttons.current[index]?.focus();
		if (index !== selected) onChange(options[index].value);
	};
	const handleKeyDown = (event, index) => {
		const position = enabled.indexOf(index);
		let target;
		if (event.key === "Home") target = enabled[0];
		else if (event.key === "End") target = enabled.at(-1);
		else if (event.key in NEXT) {
			const rtl = getComputedStyle(event.currentTarget).direction === "rtl";
			const horizontal = event.key === "ArrowLeft" || event.key === "ArrowRight";
			const step = NEXT[event.key] * (rtl && horizontal ? -1 : 1);
			target = enabled[(position + step + enabled.length) % enabled.length];
		}
		if (target === void 0) return;
		event.preventDefault();
		select(target);
	};
	return /* @__PURE__ */ jsx("div", {
		ref,
		role: "radiogroup",
		className: cx("ds-segmented", `ds-segmented--${size}`, fluid && "ds-segmented--fluid", className),
		...rest,
		children: options.map((option, index) => {
			const checked = index === selected;
			return /* @__PURE__ */ jsxs("button", {
				ref: (element) => {
					buttons.current[index] = element;
				},
				type: "button",
				role: "radio",
				"aria-checked": checked,
				className: cx("ds-segmented__segment", checked && "ds-segmented__segment--selected"),
				disabled: option.disabled,
				tabIndex: index === tabStop ? 0 : -1,
				onClick: () => select(index),
				onKeyDown: (event) => handleKeyDown(event, index),
				children: [option.icon != null && /* @__PURE__ */ jsx("span", {
					className: "ds-segmented__icon",
					"aria-hidden": "true",
					children: option.icon
				}), /* @__PURE__ */ jsx("span", {
					className: "ds-segmented__label",
					"data-label": option.label,
					children: option.label
				})]
			}, option.value);
		})
	});
});
//#endregion
export { SegmentedControl };

//# sourceMappingURL=SegmentedControl.js.map